import { formatCreditsShort } from '@/lib/billing/utils/credits'

export interface QualitySpend {
  qualityCount: number
  qualityCharges: number
  qualityPlatformCount: number
}

/** Under Text: what Conversation Quality took of it, and what the platform paid instead. */
export function QualitySpendLine({ usage }: { usage: QualitySpend }) {
  const text = qualitySpendText(usage)
  return text ? <div className="text-xs text-muted-foreground mt-0.5">{text}</div> : null
}

/**
 * The month's own numbers decide the wording, never the current payer, so a past month
 * reads right after the payer changed.
 */
export function qualitySpendText({ qualityCount, qualityCharges, qualityPlatformCount }: QualitySpend): string | null {
  const requests = qualityCount + qualityPlatformCount
  if (requests === 0) return null

  const parts = [`${requests} req`]
  if (qualityCount > 0) parts.push(formatCreditsShort(qualityCharges))
  if (qualityPlatformCount > 0) {
    parts.push(qualityCount > 0 ? `${qualityPlatformCount} not charged to your balance` : 'Not charged to your balance')
  }
  return `Conversation Quality — ${parts.join(' · ')}`
}
